<div class="model-home">
  <app-sub-header
    [badgeText]="'Healthcare Models'"
    [title]="'Models'"
    [description]="'Explore scalable models that convert data into intelligence, supporting innovation, optimization, and real-world problem solving.'"
    [iconSrc]="'/icons/sparkle.svg'"
  ></app-sub-header>

  <div
    class="model-home__shell flex flex-col gap-6 w-full min-w-0 max-w-full box-border lg:flex-row lg:items-start lg:gap-8"
  >
    <aside class="model-home__sidebar w-full shrink-0 min-w-0 lg:w-auto lg:flex-none">
      <app-asset-filter
        [config]="filterConfig"
        [isLoggedIn]="isLoggedIn"
        (filterChange)="onFilterChange($event)"
        (resetFilters)="onResetFilters()"
      ></app-asset-filter>
    </aside>

    <main class="model-home__main flex-1 min-w-0 w-full max-w-full flex flex-col gap-4">
      <app-asset-navbar
        [searchPlaceholder]="searchPlaceholderDynamic"
        [searchQuery]="searchQuery"
        [totalCount]="effectiveTotalCount"
        [showingFrom]="showingFrom"
        [showingTo]="showingTo"
        [sortOption]="sortOption"
        [viewMode]="viewMode"
        [isLoggedIn]="isLoggedIn"
        [bookmarksActive]="bookmarksActive"
        [likeActive]="likeActive"
        (searchChange)="onSearchChange($event)"
        (sortChange)="onSortChange($event)"
        (viewModeChange)="onViewModeChange($event)"
        (bookmarksClick)="onBookmarksNavbarClick()"
        (likesClick)="onLikesNavbarClick()"
      ></app-asset-navbar>

      @if (isLoading()) {
        <div
          class="model-home__grid grid gap-4 min-w-0"
          [ngClass]="viewMode === 'list' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'"
        >
          @for (_ of skeletonCardIndices; track $index) {
            <app-skeleton variant="card" />
          }
        </div>
      } @else {
        <div
          class="model-home__grid grid gap-4 min-w-0"
          [ngClass]="viewMode === 'list' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'"
        >
          @for (card of displayedModels; track card.id) {
            <app-model-card [card]="card"></app-model-card>
          }
        </div>
      }

      @if (!isLoading() && displayedModels.length === 0) {
        <p class="model-home__empty text-sm m-0 py-6 text-center">
          No models match your filters or search. Try adjusting filters or search terms.
        </p>
      }

      @if (!isLoading() && effectiveTotalPages > 1) {
        <nav class="model-home__pagination" aria-label="Model pages">
          <button
            type="button"
            class="model-home__page-btn model-home__page-btn--nav"
            [disabled]="currentPage <= 1"
            aria-label="Previous page"
            (click)="onPageChange(currentPage - 1)"
          >
            &lt;
          </button>
          @for (item of paginationItems; track $index) {
            @if (item === 'ellipsis') {
              <span class="model-home__ellipsis" aria-hidden="true">…</span>
            } @else {
              <button
                type="button"
                class="model-home__page-btn"
                [class.model-home__page-btn--active]="item === currentPage"
                [attr.aria-current]="item === currentPage ? 'page' : null"
                (click)="onPageChange(item)"
              >
                {{ item }}
              </button>
            }
          }
          <button
            type="button"
            class="model-home__page-btn model-home__page-btn--nav"
            [disabled]="currentPage >= effectiveTotalPages"
            aria-label="Next page"
            (click)="onPageChange(currentPage + 1)"
          >
            &gt;
          </button>
        </nav>
      }
    </main>
  </div>
  <app-login-modal [visible]="showLoginModal" (visibleChange)="onLoginModalVisibleChange($event)"></app-login-modal>
</div>
<app-footer></app-footer>